export class DeleteGalleryPhotoConfirm {
    constructor(optionalOptions = {}) {
        this._deletes = document.querySelectorAll('[data-action="delete-photo-confirm"]');

        if (!this._deletes) {
            this.destructor();
            return true;
        }

        this._deletes.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                window.closeAllModals();
                window.showModal('modal-user-gallery-delete-photo-success')

                return false
            })
        })
    }

    destructor() {
        this._deletes = null;
    }
}

export default new DeleteGalleryPhotoConfirm();